import styled from 'styled-components'
import { Input, Select, Button } from '@sainsburys-tech/bolt'

const Contents = styled.div`
  display: flex;
`
const Heading = styled.h3`
  font-size: ${props => props.theme.font.size['display-2']};
  font-weight: ${props => props.theme.font.weight.bold};
  margin-bottom: 15px;
`
const QandAFormat = styled.div`
  background-color: ${props => (props.type === 'question' ? props.theme.color.monochrome.lighter : '')};
  border: ${props => (props.type === 'answer' ? '2px solid black' : '')};
  padding: 10px;
  margin: 20px 0;

  & p {
    margin-bottom: 8px;
  }

  & ul {
    list-style: initial;
    padding: 0 16px;
  }
`
const InputField = styled(Input)`
  width: 70%;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    width: 100%;
  }
`
const AdditionalDetailsWrapper = styled.div`
  width: 70%;

  & label {
    font-weight: ${props => props.theme.font.weight.bold};
    margin-bottom: 8px;
    display: block;
  }
  & span {
    font-size: 0.75rem;
    margin-left: 8px;
    color: ${props => props.theme.color.monochrome.darker};
  }
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    width: 100%;
  }
`
const AdditionalDetails = styled.textarea`
  width: 100%;
  font-family: inherit;
  font-size: inherit;
  padding: 15px;
  margin-bottom: 0;
  border-color: ${props => (props.error ? props.theme.color.semantic.error.base : 'initial')};
  border-width: ${props => (props.error ? props.theme.size.border.width.md : props.theme.size.border.width.sm)};
  border-radius: ${props => (props.error ? '4px' : props.theme.size.border.radius.base)};
`
const ErrorMessage = styled.div`
  font-size: ${props => props.theme.font.size.caption};
  font-weight: ${props => props.theme.font.weight.bold};
  color: ${props => props.theme.color.semantic.error.base};
  margin-bottom: 7px;
`
const WordCount = styled.div`
  text-align: right;
  margin-bottom: 25px;
  font-size: 0.75rem;
  color: ${props => (props.error ? props.theme.color.semantic.error.base : 'initial')};
`
const FormDivider = styled.div`
  border-bottom: 1px solid ${props => props.theme.color.monochrome.light};
  margin-bottom: 16px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 25px 0;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    flex-direction: column;
    justify-content: center;
  }
`
const ButtonWrapper = styled(Button)`
  margin-right: 10%;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    margin-right: 0;
    margin-bottom: 8px;
  }
`
const SubHeading = styled.h4`
  font-size: ${props => props.theme.font.size['display-3']};
  font-weight: ${props => props.theme.font.weight.bold};
  margin-bottom: 10px;
`
const SelectInput = styled(Select)`
  width: 40%;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    width: 60%;
  }
`
const FormWrapper = styled.div`
  flex: 1;
`
const ProductDetail = styled.div`
  flex: 1;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    display: none;
  }
`
const ProductHeading = styled(SubHeading)`
  margin-top: 20px;
  text-align: center;
`
const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const IconWrapper = styled.div`
  margin-right: 8px;
`
const Icon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  background-color: ${props => props.theme.color.monochrome.lighter};
`

const AnswerHeading = styled.span`
  display: flex;
  font-size: ${props => props.theme.font.size.root};
`

const QuestionDetails = styled.div`
  padding-left: 34px;
  padding-bottom: 20px;
`

const TandCLabel = styled.a`
  text-decoration: underline;
`

export {
  Contents,
  QandAFormat,
  Heading,
  SubHeading,
  InputField,
  AdditionalDetailsWrapper,
  AdditionalDetails,
  WordCount,
  FormDivider,
  SelectInput,
  ButtonContainer,
  ButtonWrapper,
  FormWrapper,
  ProductDetail,
  ProductHeading,
  ImageWrapper,
  IconWrapper,
  Icon,
  AnswerHeading,
  QuestionDetails,
  ErrorMessage,
  TandCLabel
}
